import { render } from "./SystemStatus.vue?vue&type=template&id=a8ded1ea"
import script from "./SystemStatus.vue?vue&type=script&lang=js"
export * from "./SystemStatus.vue?vue&type=script&lang=js"

import "./SystemStatus.vue?vue&type=style&index=0&id=a8ded1ea&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__